import React, { Component } from "react";
import InputForm from "./InputForm";
import axios from "axios";


class ServicoFrame extends Component {
    state = {
        lista: [],
        codigo: {
            key: '0',
            label: '',
        },
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            this.setState({
                codigo: {
                    key: this.props.value.key,
                    label: '',
                },
            })
        }
    }

    componentDidMount() {
        this.getListaRegistros();
    }

    getListaRegistros = () => {
        this.setState({ lista: [] })
        axios.get('/servicos/lista', {
            params: {
                situacao: 'A'
            }
        }).then(response => {
            const { data } = response;
            const lista = data.map(regList => {
                return {
                    key: regList.serv_idf,
                    label: regList.serv_descricao,
                    serv_valor: regList.serv_valor,
                    serv_cod_nfse: regList.serv_cod_nfse,
                    serv_cod_nbs: regList.serv_cod_nbs,
                    serv_aliq_nfse: regList.serv_aliq_nfse,
                    serv_descricao_nfse: regList.serv_descricao_nfse,
                }
            });
            if ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) {
                lista.unshift({ key: '0', label: this.props.descricaoPrimeiroItem });
            }
            this.setState({
                lista,
            })
        }).catch(error => {
            console.error(error.response);
        })
    };

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        this.setState({ [id]: value });
        const state = {};
        const iInd = this.state.lista.findIndex(registro => String(registro.key) === String(value.key));
        state[id] = {
            key: value.key,
            label: value.label,
            serv_valor: this.state.lista[iInd].serv_valor,
            serv_cod_nfse: this.state.lista[iInd].serv_cod_nfse,
            serv_cod_nbs: this.state.lista[iInd].serv_cod_nbs,
            serv_aliq_nfse: this.state.lista[iInd].serv_aliq_nfse,
            serv_descricao_nfse: this.state.lista[iInd].serv_descricao_nfse,
        };
        this.props.onChange(state);
    };



    render() {
        const { label, id, width, disabled } = this.props;
        const { lista, codigo } = this.state;

        return (
            <span style={{}}>
                <span>{label}</span>
                <InputForm
                    type="select"
                    id={id}
                    ref={id}
                    value={codigo}
                    onChange={this.onChange}
                    data={lista}
                    validator={value => Boolean(value)}
                    showSearch
                    disabled={disabled}
                    style={{ width: width }}
                />
            </span>
        );
    }
}

export default ServicoFrame;



// WEBPACK FOOTER //
// ./src/components/ServicoFrame.js